<div class="container-fluid py-4">
  <div class="py-4 heading-container">
    <h1 class="d-inline-block align-middle m-0" data-test-id="page-heading">
      {{ 'DEACTIVATED_USERS_TITLE' | translate }}
    </h1>
  </div>
  <ul ngbNav #nav="ngbNav" (navChange)="onTabClick($event)" [(activeId)]="currentTab" class="nav-tabs">
    <li ngbNavItem="disabled_accounts">
      <a ngbNavLink [attr.data-test-id]="DISABLED_ACCOUNTS">
        {{ 'DEACTIVATED_DISABLED_ACCOUNTS' | translate }} ({{ disabledAccounts }})
      </a>

      <ng-template ngbNavContent>
        <app-grid-users-list
          [currentPage]="resolver.state.pagination?.currentPage"
          [pageSize]="pageSize"
          [totalCount]="resolver.state.pagination?.totalItemsCount"
          (pageChange)="resolver.onPageChanged($event)"
          [pagination]="true"
          [constructorData]="disabledTableData"
          [noUsersHint]="'DEACTIVATED_NO_DEACTIVATED_ACCOUNTS'"
          (action)="onTableAction($event)"
        ></app-grid-users-list>
      </ng-template>
    </li>

    <li ngbNavItem="reactivation_requests">
      <a ngbNavLink [attr.data-test-id]="REACTIVATION_REQUESTS">
        {{ 'DEACTIVATED_REACTIVATION_REQUEST' | translate }} ({{ reactivationRequests }})
      </a>

      <ng-template ngbNavContent>
        <app-grid-users-list
          [currentPage]="resolver.state.pagination?.currentPage"
          [pageSize]="pageSize"
          [totalCount]="resolver.state.pagination?.totalItemsCount"
          (pageChange)="resolver.onPageChanged($event)"
          [pagination]="true"
          [constructorData]="reactivationRequestTableData"
          [noUsersHint]="'DEACTIVATED_NO_REACTIVATION_REQUESTS'"
          (action)="onTableAction($event)"
        ></app-grid-users-list>
      </ng-template>
    </li>

    <li ngbNavItem="declined_requests">
      <a ngbNavLink [attr.data-test-id]="DECLINED_REQUESTS">
        {{ 'DEACTIVATED_DECLINED_REQUEST' | translate }} ({{ declinedRequests }})
      </a>

      <ng-template ngbNavContent>
        <app-grid-users-list
          [currentPage]="resolver.state.pagination?.currentPage"
          [pageSize]="pageSize"
          [totalCount]="resolver.state.pagination?.totalItemsCount"
          (pageChange)="resolver.onPageChanged($event)"
          [pagination]="true"
          [constructorData]="declinedRequestTableData"
          [noUsersHint]="'DEACTIVATED_NO_DECLINED_REQUESTS'"
          (action)="onTableAction($event)"
        ></app-grid-users-list>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
